import { useState, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Typography } from 'antd'
import { textSubtitle } from '../../styles/AuthStyles'
import { normalizeUsPhone } from '../../utils/phoneNumber'
import { SendCodeForm } from '../Forms/SendCodeForm'

type PhoneNumberStepProps = {
  title: string
  subtitle: string
  onSubmit: (phone: string) => void
  loading: boolean
  error: string | null
  children?: ReactNode
}

export const PhoneNumberStep = ({ title, subtitle, onSubmit, loading, error, children }: PhoneNumberStepProps) => {
  const { t } = useTranslation()
  const [invalid, setInvalid] = useState(false)

  const handleFinish = (raw: string) => {
    const phone = normalizeUsPhone(raw)

    setInvalid(phone === null)

    if (phone) onSubmit(phone)
  }

  return (
    <div data-testid='phone-number-step'>
      <Typography.Title
        level={2}
        data-testid='phone-number-title'
        style={{ textAlign: 'center', marginBottom: '16px', fontWeight: 400 }}
      >
        {title}
      </Typography.Title>
      <Typography.Text
        type='secondary'
        data-testid='phone-number-subtitle'
        style={{ ...textSubtitle, marginBottom: '40px' }}
      >
        {subtitle}
      </Typography.Text>
      {(invalid || error) && (
        <Alert
          data-testid='phone-number-error'
          title={invalid ? t('phone_auth_invalid_phone') : error}
          type='error'
          showIcon
          style={{ marginBottom: '16px' }}
        />
      )}
      <SendCodeForm
        onFinish={(values) => handleFinish(values.to)}
        loading={loading}
        showConsent={false}
      />
      {children}
    </div>
  )
}
